import "./slotsTemplatesTable.scss";
import { SlotsTemplatesTableProps } from "./types";
import { SlotsConstants } from "constants/slots";
import { compensateTime, formatDDMMYYYY } from "utils/date";
import { SlotTemplateType } from "sagas/types/slotTemplates";
import { useTranslation } from "react-i18next";
import "./i18n";
import { HeaderType, Table } from "@pickit/pickit-components";
import useTableConfig from "hooks/useTableConfig";

const SlotsTemplatesTable = ({
  seeMore,
  templates,
  testId,
  collapse,
  openModal,
  onSeeMoreClick,
}: SlotsTemplatesTableProps) => {
  const { t } = useTranslation("tableTemplates");
  const { fontSize, rowCount } = useTableConfig(collapse);
  const headers: HeaderType<SlotTemplateType>[] = [
    {
      key: "region.name",
      label: t("region"),
      testId: "region",
    },
    {
      key: "workZone.name",
      label: t("workzone"),
      testId: "workzone",
    },
    {
      key: ["startAt", "finishAt"],
      label: t("shift"),
      testId: "time",
      textConfig: {
        formatter: compensateTime,
        separator: " - ",
      },
    },
    {
      key: "days",
      label: t("frecuency"),
      testId: "frecuency",
      textConfig: {
        formatter: ((days: boolean[]) =>
          SlotsConstants.getFrequencyRange(days)) as any,
      },
    },
    {
      key: "updateAt",
      label: t("updatedAt"),
      testId: "update",
      textConfig: {
        formatter: (date: string) => formatDDMMYYYY(date),
      },
    },
  ];

  return (
    <Table<SlotTemplateType>
      data={templates}
      headers={headers}
      pagination="view-more-button"
      hasMoreRows={seeMore}
      loadMoreRows={onSeeMoreClick}
      testId={testId}
      rowCount={rowCount}
      fontSize={fontSize}
      onClickRow={(template) => openModal(template.id)}
    />
  );
};

export default SlotsTemplatesTable;
